import { render, staticRenderFns } from "./newDictionary2.vue?vue&type=template&id=89f28c9e&scoped=true"
import script from "./newDictionary2.vue?vue&type=script&lang=js"
export * from "./newDictionary2.vue?vue&type=script&lang=js"
import style0 from "./newDictionary2.vue?vue&type=style&index=0&id=89f28c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f28c9e",
  null
  
)

/* custom blocks */
import block0 from "./newDictionary2.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports